import styled from 'styled-components';

const StyledInput = styled.input<{
	$active?: boolean;
	$error?: boolean;
	$activeBgColor?: string;
	$activeTextColor?: string;
	$placeholderOpacity?: number;
}>`
	width: 100%;
	background-color: rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	color: #ffffff;
	border: 1px solid rgba(255, 255, 255, 0.1);
	padding: 0 10px;
	transition:
		color 0.3s ease,
		background-color 0.3s ease,
		border 0.3s ease;

	${({ $active, $activeBgColor, $activeTextColor }) =>
		$active &&
		`
		color: ${$activeTextColor};
		background-color: ${$activeBgColor};
	`}

	${({ $error }) =>
		$error &&
		`
		color: #C71E1E;
		background-color: rgba(199, 30, 30, 0.25);
		border: 1px solid rgba(199, 30, 30, 0.5);
		`}

	&::placeholder {
		color: rgba(
			255,
			255,
			255,
			${({ $placeholderOpacity }) => $placeholderOpacity}
		);
		transition: color 0.3s ease;
		user-select: none;
		-webkit-user-select: none;
	}

	&:hover {
		color: #000000;
		background-color: #ffffff;

		&::placeholder {
			color: rgba(0, 0, 0, ${({ $placeholderOpacity }) => $placeholderOpacity});
		}
	}

	&:focus-visible {
		outline: none;
	}
`;

export { StyledInput };
